import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './style.css';
import './assets/styles/iconfont.css';
import '@/assets/styles/index.scss'; // global css
import store from '@/store';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import { zhCn } from 'element-plus/es/locale/index.mjs';
import { findPathById,formatTime100,parseTime99,parseTime,parseTime66, handleTimeRange_send,handleTimeRange_creat,handleTimeRange,handleTimeRange_submit,handleTimeRange_update,formatDate,handleTimeRange_pace,handleTimeRange_edit} from "./utils/base";
import App from './App.vue';
import router from './router';
import './permission' // permission control
import Pagination from "@/components/Pagination";
import tab from '@/plugins/tab.js';
import modal from '@/plugins/modal.js';
import request from '@/utils/request'
import svgStyle from '@/components/svgStyle';
import RightToolbar from "@/components/RightToolbar"
const app = createApp(App);
app.config.globalProperties.$parseTime=parseTime;
app.config.globalProperties.$parseTime66=parseTime66;
app.config.globalProperties.$handleTimeRange=handleTimeRange;
app.config.globalProperties.$handleTimeRange_creat=handleTimeRange_creat;
app.config.globalProperties.$handleTimeRange_submit=handleTimeRange_submit;
app.config.globalProperties.$handleTimeRange_update=handleTimeRange_update;
app.config.globalProperties.$formatDate=formatDate;
app.config.globalProperties.$handleTimeRange_pace=handleTimeRange_pace;
app.config.globalProperties.$handleTimeRange_edit=handleTimeRange_edit;
app.config.globalProperties.$handleTimeRange_send=handleTimeRange_send;
app.config.globalProperties.$parseTime99=parseTime99;
app.config.globalProperties.$formatTime100=formatTime100;
app.config.globalProperties.$findPathById=findPathById;
app.config.globalProperties.$tab = tab;
app.config.globalProperties.$modal = modal;
app.config.globalProperties.$request = request;
app.config.globalProperties.$sourceurl = 'http://192.168.0.111:48080/';
app.use(store);
app.use(router);
app.use(ElementPlus,{locale:zhCn});
app.component('Pagination', Pagination);
app.component('RightToolbar', Pagination);
app.component('svgStyle', svgStyle);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }
app.mount('#app');
